import api from "./api";

export const pushSupported = () =>
  typeof window !== "undefined" &&
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window;

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
};

const bufToBase64 = (buf) =>
  window.btoa(String.fromCharCode.apply(null, new Uint8Array(buf)));

const getRegistration = async () => {
  const existing = await navigator.serviceWorker.getRegistration("/");
  if (existing) return existing;
  return navigator.serviceWorker.register("/sw.js", { scope: "/" });
};

export const isPushEnabled = async () => {
  if (!pushSupported() || Notification.permission !== "granted") return false;
  try {
    const reg = await navigator.serviceWorker.getRegistration("/");
    if (!reg) return false;
    const sub = await reg.pushManager.getSubscription();
    return !!sub;
  } catch (e) {
    return false;
  }
};

export const enablePush = async () => {
  if (!pushSupported()) throw new Error("unsupported");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("denied");

  const reg = await getRegistration();
  await navigator.serviceWorker.ready;

  const { data } = await api.get("/push/vapid-public-key");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    });
  }

  const payload = {
    endpoint: sub.endpoint,
    keys: {
      p256dh: bufToBase64(sub.getKey("p256dh")),
      auth: bufToBase64(sub.getKey("auth")),
    },
  };
  await api.post("/push/subscribe", payload);
  await api.post("/push/test");
  return true;
};

export const disablePush = async () => {
  const reg = await navigator.serviceWorker.getRegistration("/");
  if (!reg) return;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    try {
      await api.post("/push/unsubscribe", {
        endpoint: sub.endpoint,
        keys: {
          p256dh: bufToBase64(sub.getKey("p256dh")),
          auth: bufToBase64(sub.getKey("auth")),
        },
      });
    } catch (e) {}
    await sub.unsubscribe();
  }
};
